module.exports = __webpack_public_path__ + "static/Set-Style-WT-9601bc1c5eab18faaa7fb3915b0088cc.png";